// App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import HomePage from "./pages/HomePage/HomePage";

//calculator imports
import ProteinIntakeCalculator from "./pages/Calculator/ProteinIntakeCalculator/ProteinIntakeCalculator";
import CalorieCalculator from "./pages/Calculator/CalorieCalculator/CalorieCalculator";
import BodyFatCalculator from "./pages/Calculator/BodyFatCalculator/BodyFatCalculator";
import BMICalculator from "./pages/Calculator/BMICalculator/BMICalculator";
import AdvancedProteinIntakeCalculator from "./pages/Calculator/AdvancedProteinIntakeCalculator/AdvancedProteinIntakeCalculator";

//legal links imports
import PrivacyPolicy from "./pages/LegalLinks/PrivacyPolicy/PrivacyPolicy";
import AboutUs from "./pages/LegalLinks/AboutUs/AboutUs";
import ContactUs from "./pages/LegalLinks/ContactUs/ContactUs";
import Disclaimer from "./pages/LegalLinks/Disclaimer/Disclaimer";
import Sitemap from "./pages/LegalLinks/Sitemap/Sitemap";
import TermsAndConditions from "./pages/LegalLinks/TermsAndConditions/TermsAndConditions";

import "./App.css";

const StandalonePage = ({ children, title, description, keywords }) => (
  <div className="StandalonePage">
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
    </Helmet>
    <Navbar />
    <main>{children}</main>
    <Footer />
  </div>
);

const App = () => {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <StandalonePage
              title="GetFitFast - Achieve Your Dream Body in Less Time"
              description="Welcome to GETFITFAST - Achieve Your Dream Body in Less Time."
              keywords="protein intake calculator, fitness, muscle gain, weight loss, health, wellness, nutrition, diet, exercise, protein needs"
            >
              <HomePage />
            </StandalonePage>
          }
        />
        <Route
          path="/calculator/protein-intake-calculator"
          element={
            <StandalonePage
              title="Protein Intake Calculator for Muscle Gain & Weight Loss"
              description="Calculate your optimal protein intake to maximize muscle gain, weight loss, and overall fitness goals with this easy-to-use protein intake calculator."
              keywords="protein intake for muscle gain calculator, protein intake calculator for muscle gain, protein intake for weight loss, protein calculator for muscle gain, protein intake muscle gain, protein calculator workout"
            >
              <ProteinIntakeCalculator />
            </StandalonePage>
          }
        />

        <Route
          path="/calculator/advanced-protein-calculator"
          element={
            <StandalonePage
              title="Advanced Protein Intake Calculator for Muscle Gain & Weight Loss"
              description="Use this advanced protein intake calculator to calculate your precise protein needs for muscle growth, weight loss, and fitness progress with more detailed metrics."
              keywords="protein intake for building muscle calculator, protein intake muscle gain calculator, protein intake calculator for muscle gain, protein calculator for muscle gain, protein intake for muscle gain, muscle gain protein intake calculator"
            >
              <AdvancedProteinIntakeCalculator />
            </StandalonePage>
          }
        />

        <Route
          path="/calculator/calorie-calculator"
          element={
            <StandalonePage
              title="Calorie Calculator"
              description="Calculate your daily calorie needs for weight management."
              keywords="calorie calculator, nutrition, health"
            >
              <CalorieCalculator />
            </StandalonePage>
          }
        />
        <Route
          path="/calculator/body-fat-calculator"
          element={
            <StandalonePage
              title="Body Fat Calculator"
              description="Estimate your body fat percentage with our simple calculator."
              keywords="body fat calculator, fitness, health"
            >
              <BodyFatCalculator />
            </StandalonePage>
          }
        />
        <Route
          path="/calculator/bmi-calculator"
          element={
            <StandalonePage
              title="BMI Calculator"
              description="Calculate your body mass index to assess your weight."
              keywords="BMI calculator, health, fitness"
            >
              <BMICalculator />
            </StandalonePage>
          }
        />
        <Route
          path="/legal-links/privacy-policy"
          element={
            <StandalonePage
              title="Privacy Policy"
              description="Read our privacy policy regarding your data."
              keywords="privacy policy, data protection, terms"
            >
              <PrivacyPolicy />
            </StandalonePage>
          }
        />
        <Route
          path="/legal-links/terms"
          element={
            <StandalonePage
              title="Terms and Conditions"
              description="Review our terms and conditions for using the site."
              keywords="terms and conditions, policy"
            >
              <TermsAndConditions />
            </StandalonePage>
          }
        />
        <Route
          path="/legal-links/sitemap"
          element={
            <StandalonePage
              title="Sitemap"
              description="Find all pages of the GETFITFAST website."
              keywords="sitemap, website navigation"
            >
              <Sitemap />
            </StandalonePage>
          }
        />
        <Route
          path="/legal-links/disclaimer"
          element={
            <StandalonePage
              title="Disclaimer"
              description="Read our disclaimer regarding health and wellness information."
              keywords="disclaimer, health information, terms"
            >
              <Disclaimer />
            </StandalonePage>
          }
        />
        <Route
          path="/legal-links/contact"
          element={
            <StandalonePage
              title="Contact Us"
              description="Get in touch with us for more information."
              keywords="contact, inquiries, support"
            >
              <ContactUs />
            </StandalonePage>
          }
        />
        <Route
          path="/legal-links/about"
          element={
            <StandalonePage
              title="Abous Us"
              description="Get in know more about us."
              keywords="About us, inquiries, support"
            >
              <AboutUs />
            </StandalonePage>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
